import { Row, Col, Form } from "antd";
import { ReleaseTypeEnum } from "shared/enums/ReleaseTypeEnum";
import { removeMarkdown } from "shared/helpers/string-helper";
import { generateScheduleQuincyByReleases } from "shared/service/StrmService";
import ReleaseScheduleQuincy from "../../release-schedule-quincy/ReleaseScheduleQuincy";
import { useTranslation } from "react-i18next";
import { formatReleasesToRequest } from "../../interfaces";
import logger from "shared/service/LoggerService";

const QuincyStep = ({ isVisible }: { isVisible: boolean }) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();

  const generateContent = async (event?: any) => {
    let response = "";
    try {
      const formValues = form.getFieldsValue();
      const request: any = {
        releases: [
          ...formatReleasesToRequest(
            ReleaseTypeEnum.Single,
            formValues.singles,
          ),
          ...formatReleasesToRequest(ReleaseTypeEnum.Album, formValues.albums),
          ...formatReleasesToRequest(ReleaseTypeEnum.EP, formValues.eps),
        ],
        aboutCreation: formValues.aboutCreation,
        prompt: event?.prompt,
      };
      const res: any = await generateScheduleQuincyByReleases(request);
      response = removeMarkdown(
        res?.response?.schedulePlanQuincy ?? "",
      );
    } catch (err) {
      logger.error(err);
    } finally {
      return response;
    }

  }

  return <Row>
    <Col span={24} className="header">
      <p className="title required-icon">
        {t("pages.ReleasesSchedule.steps.quincy.title")}
      </p>
      <p className="subtitle">
        {t("pages.ReleasesSchedule.steps.quincy.subtitle")}
      </p>
    </Col>
    <Col span={24}>
      <ReleaseScheduleQuincy
        generateContent={generateContent}
        fieldName="aICurrentPlan"
        fieldNameSuggested="aISuggestedPlan"
        isVisible={isVisible}
      />
    </Col>
  </Row>
};

export default QuincyStep;